import {connect} from 'react-redux'
import * as ordersActions from "../actions/ordersActions";
import OrderRedirect from "../../Components/Orders/OrdersGrid/OrderStatus/OrderRedirect/OrderRedirect";

const mapStateToProps = (store) => {
    return {
        redirectToBid: store.businessReducer.business.integrationOrdersRedirection.bid
    };
};

const mapDispatchToProps = {
    redirectOrder: ordersActions.redirectOrderAction
};

const OrderRedirectContainer = connect(mapStateToProps, mapDispatchToProps)(OrderRedirect);

export default OrderRedirectContainer;